// src/components/CountryContent.tsx
"use client";

import dynamic from "next/dynamic";
import React from "react";

const CountryContentClient = dynamic(
  () => import("./CountryContentClient"),
  { ssr: false }
);

interface CountryContentProps {
  countryName: string;
  networks: string[];
}

const CountryContent: React.FC<CountryContentProps> = (props) => {
  return (
    <div className="min-h-[600px]">
      <CountryContentClient {...props} />
    </div>
  );
};

export default CountryContent;
